module.exports = __webpack_public_path__ + "img/invoice-icon.601352fc.svg";